import fetchPlus, {
  type FetchPlusOptions,
  type FetchPlusResponse,
} from "fetch-plus"

import humps from "humps"

export { ApiError } from "fetch-plus"

const methods = [
  "get",
  "post",
  "put",
  "patch",
  "delete",
] as const

export type ApiResponse<T> = FetchPlusResponse<T>

type ApiMethod = <T>(
  url: string,
  options?: FetchPlusOptions
) => Promise<ApiResponse<T>>

type Api = Record<(typeof methods)[number], ApiMethod>

export const api = {} as Api

for (const method of methods) {
  api[method] = async <T>(
    path: string,
    options: FetchPlusOptions = {}
  ) => {
    const maybeCsrfCookie =
      document.cookie
        .split(";")
        .find((row) => row.trim().startsWith("csrftoken="))
        ?.split("=")[1] || undefined

    const headers = new Headers(options.headers)
    if (maybeCsrfCookie && !headers.has("X-CSRFTOKEN")) {
      headers.set("X-CSRFTOKEN", maybeCsrfCookie)
    }

    return fetchPlus<T>(`${__API_ROOT__}${path}`, {
      ...options,
      body: options.body
        ? humps.decamelizeKeys(options.body)
        : undefined,
      method: method.toUpperCase(),
      headers,
    })
  }
}
